import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative h-screen w-full flex items-end justify-center overflow-hidden pb-32" data-id="element-49">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-fuchsia-600" data-id="element-50" />

      {/* Gradient Overlays */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-brand-black via-brand-black/50 to-transparent" data-id="element-51" />
      <div className="absolute inset-0 z-10 bg-brand-black/20" data-id="element-52" />

      {/* Content — bottom-aligned for editorial feel */}
      <motion.div className="relative z-20 max-w-7xl w-full mx-auto px-6 md:px-12" variants={containerVariants} initial="hidden" animate="show" data-id="element-53">
        <motion.div variants={itemVariants} className="mb-4" data-id="element-54">
          <span className="inline-block px-3 py-1 bg-brand-gold text-brand-black text-xs font-semibold tracking-widest uppercase" data-id="element-55">
            For Sale
          </span>
        </motion.div>

        <motion.h1 variants={itemVariants} className="font-heading text-6xl md:text-8xl lg:text-[10rem] text-white leading-[0.85] uppercase mb-4" data-id="element-56">
          11 Northcote
          <br data-id="element-57" />
          <span className="text-brand-gold" data-id="element-58">Street</span>
        </motion.h1>

        <motion.p variants={itemVariants} className="text-white/60 text-lg md:text-xl tracking-wide uppercase font-light mb-8" data-id="element-59">
          Richmond VIC 3121 &nbsp;·&nbsp; Commercial
        </motion.p>

        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-start gap-4" data-id="element-60">
          <a href="#enquire" className="px-8 py-4 bg-brand-gold text-brand-black uppercase tracking-widest text-sm font-semibold hover:bg-white transition-colors duration-300" data-id="element-61">
            Enquire Now
          </a>
          <a href="#gallery" className="px-8 py-4 border border-white/30 text-white uppercase tracking-widest text-sm font-medium hover:border-brand-gold hover:text-brand-gold transition-colors duration-300" data-id="element-62">
            View Gallery
          </a>
        </motion.div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-1" data-id="element-63">
        <motion.div animate={{
        y: [0, 6, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-64">
          <ChevronDown className="text-brand-gold/60" size={20} data-id="element-65" />
        </motion.div>
      </motion.div>
    </section>;
}